import React from 'react'
import { Dashboard, ErrorBoundary } from '@cps'
import { IonApp } from '@ionic/react'
import { IonReactRouter } from '@ionic/react-router'
import { getEnv, getPlatform } from '@utils'
import '@css/index.scss'

const { isDebug, isPrd } = getEnv()
const { isComputerBrower, isWeixinMiniProgram } = getPlatform()

// 非本地环境且非浏览器环境开启vconsole
if ((!isPrd && !isComputerBrower) || isDebug) {
  const VConsole = require('vconsole')
  new VConsole()
  // new window.VConsole()
}

const App: React.FC = () => {
  return (
    <IonApp className={isWeixinMiniProgram ? 'weixin-mini' : ''}>
      <ErrorBoundary>
        <IonReactRouter>
          <Dashboard />
        </IonReactRouter>
      </ErrorBoundary>
    </IonApp>
  )
}

export default App
